import React, { useEffect, useState, useRef } from 'react';
import Callable from '../../../../shared/Callable';
import { connect } from 'react-redux';
import { PERSONAL_INFO_SAVING, EMPLOYERID_UPDATED_SUCCESSFULLY, EMPLOYERID_UPDATED_FAILURE, ENABLE_NEXT_BUTTON, SHOW_DO_LATER } from '../../../../redux/actionTypes';
import CommonToast from '../../../../shared/components/common-toast-message/CommonToast';
import analyticsService from '../../../../shared/analytics/analytics-service';

function EmployerIdScreen(props) {
  const [employeeId, updateEmployeeId] = useState("");
  const [employeeIdValid, updateEmployeeidValid] = useState(true);
  const [disableButton, updateDisableButton] = useState(true);
  const [startEmployerLoader, updateStartEmployerLoader] = useState(false);
  const [isToastModalOpen, setIsToastModalOpen] = useState(false);
  const [showDoLater, updateShowDoLater] = useState(false);
  const [toastData, updateToastData] = useState({ message: '', type: '' });
  const [errorAnalyticsFired, setErrorAnalyticsFired] = useState(false);

  function onChangeEmployeeId(value) {
    updateEmployeeId(value);
    if(validateEmployeeId(value)){
      updateEmployeeidValid(true);
      updateDisableButton(false);
      setErrorAnalyticsFired(false);
    }else{
      updateEmployeeidValid(false);
      updateDisableButton(true);
    }
  }

  function validateEmployeeId(value) {
    if (!props.employeeInfo?.employeeIdPattern) {
        if (value && value.length > 0) {
            return true;
        } else {
            return false;
        }
    } else {
        const patternString = props.employeeInfo?.employeeIdPattern;
        const regex = new RegExp(patternString);
        if (regex.test(value)) {
            return true;
        } else {
            return false;
        }
    }
}

  function hasAddressData(address) {
    return Object.values(address).some(
      v =>
        (typeof v === "string" && v.trim() !== "") ||
        (typeof v === "number" && !Number.isNaN(v))
    );
  }

  function saveEmployerId(data) {
    if (data) {
      var homeAddress =  hasAddressData(props.joinCommuteData.updatedHomeAddress) ? props.joinCommuteData.updatedHomeAddress : props.profile.homeAddress;
      const saveObject = {
        homeAddress: homeAddress,
        mailingAddress: hasAddressData(props.profile.mailingAddress) ? props.profile.mailingAddress : homeAddress,
        phone: props.profile.phone,
        secondPhone: props.profile.secondPhone,
        employeeId: data
      }
     updateStartEmployerLoader(true);
     props.updateEmployerId(saveObject, true);
    }
  }

  useEffect(() => {
    if (props.employeeIdUpdated) {
      updateStartEmployerLoader(false);
      props.updateEmployerIdSuccess(false);
      updateToastData({
        message: 'Employee ID updated successfully',
        type: 'success'
      });
      setIsToastModalOpen(true);
      props.updateEnableNextbutton(true);
      analyticsService.analyticsProcessEvent({
        "event": "click_generic",
        "context": {
          "event_action": "submit"
        }
      });
    }
    if (props.employeeIdUpdatedFailed) {
      updateStartEmployerLoader(false);
      props.updateEmployerIdFailure(false);
      updateToastData({
        message: props.employeeIdErrorMessage,
        type: 'error'
      });
      analyticsService.analyticsProcessEvent({
        "event": "user_error",
        "context": {
          "event_action": props.employeeIdErrorMessage?.toLowerCase()
        }
      });
      updateShowDoLater(true);
      props.updateShowDoLater(true);
      setIsToastModalOpen(true);
      props.updateEnableNextbutton(true);
    }
  }, [props.employeeIdUpdated, props.employeeIdUpdatedFailed, props.employeeIdErrorMessage])

  useEffect(() => {
    if (props.employeeInfo && props.employeeInfo.employeeId) {
      updateEmployeeId(props.employeeInfo.employeeId)
    }
    if( validateEmployeeId(props.employeeInfo.employeeId) && props.enableOnboardingNextButton ){
      updateDisableButton(false);
    }
  }, [props.employeeInfo])

  useEffect(() => {
    if(props.showDoLater){
      updateShowDoLater(true);
    }
  },[props.showDoLater]);


  useEffect(() => {
      if (employeeId && employeeId.length > 0 && !employeeIdValid && !errorAnalyticsFired) {
        analyticsService.analyticsProcessEvent({
          "event": "user_error",
          "context": {
            "event_action": "employee id doesn't match the required format"
          }
        });
        setErrorAnalyticsFired(true);
      } else if (!employeeIdValid && employeeId.length === 0 && errorAnalyticsFired) {
        analyticsService.analyticsProcessEvent({
          "event": "user_error",
          "context": {
            "event_action": "employee id is required"
          }
        });
        setErrorAnalyticsFired(false);
      }
  },[employeeIdValid, errorAnalyticsFired, employeeId]);

  useEffect(() => {
    analyticsService.getPageName({
      'pagename': "customer onboarding/enter your employee id",
      'process': "customer onboarding"
    });
  }, []);

  return (
    <div className='screen-container'>
      <h1 className='heading'>
        Enter Your Employee ID
      </h1>
      <div className='content-container'>
        <div className="employer-id-container">
          <div className='content'>
            <div className='sub-heading-emp'>* Required Field</div>
            <div className='header'>Employee ID Required</div>
            <div className='subtext'>Your employer requires that we collect your Employee ID. <br />If you don’t know your Employee ID, call your employer.</div>
            <div className='employer-field'>
              <fieldset className='field'>
                <div className='label'>
                  <label htmlFor='employeeid'>Employee ID*</label><span className='id-description'>{`(${props.employeeInfo?.employeeIdPatternDescription ? props.employeeInfo?.employeeIdPatternDescription : "Enter at least one character"})`}</span>
                </div>
                <input id='employeeid' aria-describedby="employeeIdError" type='text' className={employeeIdValid ? 'employee-id-field' : 'employee-id-field error'} onChange={(e) => onChangeEmployeeId(e.target.value)} value={employeeId || ''} ></input>
                {employeeIdValid ? null
                  :
                  <div className="invalid-text" aria-live='assertive'>
                    { employeeId && employeeId.length > 0 ? 'Employee ID doesn’t match the required format' : "Employee ID is required"}
                  </div>
                }
              </fieldset>
              {
                startEmployerLoader &&
                <span aria-live='assertive' role='alert'>
                  <div className="employer-loader" aria-busy='true'><span className='screenreader-only'>uploading image</span></div>
                </span>
              }
            </div>
            <div className='footer'>
              <div className='second-line'>For any other questions call <Callable className="greentext" phone="800 VAN-4-WORK" analyticsEvent={true} defaultAnalytics={true} /></div>
            </div>

          </div>

          <div className='button-container'>
            <button tabIndex={0} disabled={(disableButton || startEmployerLoader)} className='continue-button' onClick={() => saveEmployerId(employeeId)} >Submit</button>
          </div>
          {
            showDoLater &&
            <div className='do-it-later' onClick={() => {
              analyticsService.analyticsProcessEvent({
                "event": "click_generic",
                "context": {
                  "event_action": "add it later"
                }
              });
              props.handleSlider();
            } }> ADD IT LATER </div>
          }

          <CommonToast message={toastData.message} type={toastData.type} isOpen={isToastModalOpen} closeToast={() => setIsToastModalOpen(!isToastModalOpen)} timeOut={6000} />
        </div>

      </div>
    </div>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    updateEmployerId(data, updateEIdFromOnboarding) {
      dispatch({ type: PERSONAL_INFO_SAVING, data: { ...data, updateEIdFromOnboarding } });
    },
    updateEmployerIdSuccess(data) {
      dispatch({ type: EMPLOYERID_UPDATED_SUCCESSFULLY, data: data });
    },
    updateEmployerIdFailure(data) {
      dispatch({ type: EMPLOYERID_UPDATED_FAILURE, data: data });
    },
    updateEnableNextbutton(data) {
      dispatch({ type: ENABLE_NEXT_BUTTON, data: data });
    },
    updateShowDoLater(data) {
      dispatch({ type: SHOW_DO_LATER, data: data });
    }
  }
}

function mapStateToProps(state) {
  return {
    employeeInfo: state?.profile?.employee,
    profile: state.profile,
    employeeIdUpdated: state?.joinCommute?.employeeIdUpdated,
    employeeIdUpdatedFailed: state?.joinCommute?.employeeIdUpdatedFailed,
    employeeIdErrorMessage: state?.joinCommute?.employeeIdErrorMessage,
    joinCommuteData: state?.joinCommute,
    enableOnboardingNextButton: state?.joinCommute?.enableOnboardingNextButton,
    showDoLater: state?.joinCommute?.showDoLater
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmployerIdScreen);